// HACK: Phase4Step2-2終了間際にESLintのルールが変更になり、ロジックは変更出来なかったため回避。
/* eslint-disable max-lines */
/********************************/
/*          About vuex          */
/********************************/
// The MIT License (MIT)
//
// Copyright (c) 2015-present Evan You
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import { mapState, mapActions } from 'vuex';
import config from '../../../../share/config';
import session from '../../../../share/session';
import individualDiagnose from '../../../../share/util/individualDiagnose';
import individualWorkSupportUtil from '../../../../share/util/individualWorkSupportUtil';
import error from '../../../../common/nodejs/errors';
import utils from '../../../../share/util/utils';
import inputValidator from '../../../../share/util/inputValidator';
import { getAbbrSysName } from '../../../../share/util/systemName';
import { fixNumberWithDecimal } from "../../../../common/nodejs/mathFunctions";
const DiagSystemUtils = require('../../../../common/nodejs/diagSystemUtils');

/** 各フェーズ定義 */
const PHASE = {
  START: 'start',                                           // 開始確認
  CONDITION_CHECK: 'conditionCheck',                        // 車両状態確認
  CALIBRATION: 'calibration',                               // キャリブレーション不良表示
  POINT_PRECAUTIONS1: 'pointPre1',                          // センサ０点調整注意事項表示1
  POINT_PRECAUTIONS2: 'pointPre2',                          // センサ０点調整注意事項表示2
  POINT_PRECAUTIONS3: 'pointPre3',                          // センサ０点調整注意事項表示3
  POINT_PRECAUTIONS4: 'pointPre4',                          // センサ０点調整注意事項表示4
  CREW_DETECTION: 'crewDetection',                          // 乗員検知システム故障確認(処理中画面)
  SUCCESS_POINT: 'successPoint',                            // センサ０点調整成功表示
  FAILED_SYSTEM_FAILURE: 'failedSystemFailure',             // 乗員検知システム故障あり表示
  FAILED_TIMEOUT: 'failedTimeout',                          // タイムアウト表示
  FAILED_POINT: 'failedPoint',                              // エラーコード表示
  SENSITIVITY_PRECAUTIONS1: 'sensitivityPre1',              // センサ感度検査注意事項表示1
  SENSITIVITY_PRECAUTIONS2: 'sensitivityPre2',              // センサ感度検査注意事項表示2
  SENSITIVITY_PRECAUTIONS3: 'sensitivityPre3',              // センサ感度検査注意事項表示3
  SENSITIVITY_PRECAUTIONS4: 'sensitivityPre4',              // センサ感度検査注意事項表示4
  SENSITIVITY_PRECAUTIONS5: 'sensitivityPre5',              // センサ感度検査注意事項表示5
  SENSITIVITY_PRECAUTIONS6: 'sensitivityPre6',              // センサ感度検査注意事項表示6
  SENSITIVITY_PRECAUTIONS7: 'sensitivityPre7',              // センサ感度検査注意事項表示7
  INPUT_INST: 'inputInst',                                  // 錘質量入力指示表示
  INPUT: 'input',                                           // 錘質量入力
  INSPECTION_PRE: 'inspectionPre',                          // 検査準備表示
  READOUT: 'readout',                                       // 検査データ読出し(処理中画面)
  SUCCESS_SENSITIVITY: 'successSensitivity',                // 合格表示
  CONDITION_FAILED: 'conditionFailed',                      // 不合格表示
  FAILED_SENSITIVITY: 'failedSensitivity',                  // 感度検査エラー表示
  FAILED: 'failed'                                          // 汎用エラー表示
};

/** 乗員検知システム故障確認対象外DTC */
const notSubjectDTC = {
  ABG: ['B11E3', 'B1783', 'B1784', 'B1785', 'B1786', 'B178C', 'B1796', 'B121900', 'B121000', 'B121154', 'B00C04A', 'B00C14A', 'B00C24A', 'B00C34A'],
  OCPT: ['B178B', 'B178C', 'B1783', 'B1784', 'B1785', 'B1786']
};
/** キャリブレーション不良対象DTC */
const calibrationFailureDTC = {
  ABG: ['B178C', 'B1796', 'B121154', 'B00C04A', 'B00C14A', 'B00C24A', 'B00C34A'],
  OCPT: ['B178B', 'B178C']
};

export default {
  name: 'requirement049',
  data() {
    return {
      phase: PHASE.START,
      isLoading: false,
      displayInfo: '',
      inputWeight: '',
      timeRemainSec: 0, // 取得値保持用
      displaySec: 0,    // 表示・カウントダウン用
      timerID: null,
      systemId: '',
      // ダイアログフラグ
      modal_requirement_049: false,
      isAlertValidation: {}
    };
  },

  props: {
    i18nWsKey: { type: String, default: '', required: true },
    workSupportId: { type: Number, default: '', required: true },
  },

  computed: {
    ...mapState({
      netAppId: state => state.netAppConnector.pairingAppId
    }),
    /**
     * ダイアログのヘッダー色
     */
    headerColor() {
      switch (this.phase) {
        case PHASE.FAILED_SYSTEM_FAILURE:
        case PHASE.FAILED_TIMEOUT:
        case PHASE.FAILED_POINT:
        case PHASE.CONDITION_FAILED:
        case PHASE.FAILED_SENSITIVITY:
        case PHASE.FAILED:
          return 'danger';
        case PHASE.SUCCESS_POINT:
        case PHASE.SUCCESS_SENSITIVITY:
          return 'success';
        case PHASE.INPUT:
        default:
          return 'secondary';
      }
    },
    /**
     * ダイアログのヘッダー表示文言
     */
    headerValue() {
      switch (this.phase) {
        case PHASE.CREW_DETECTION:
        case PHASE.READOUT:
          return this.$t(`individual.common_title_execution`);
        case PHASE.SUCCESS_POINT:
        case PHASE.SUCCESS_SENSITIVITY:
          return this.$t(`message.common_title_success`);
        case PHASE.FAILED_SYSTEM_FAILURE:
        case PHASE.FAILED_TIMEOUT:
        case PHASE.FAILED_POINT:
        case PHASE.CONDITION_FAILED:
        case PHASE.FAILED_SENSITIVITY:
        case PHASE.FAILED:
          return this.$t(`message.common_title_error`);
        case PHASE.INPUT:
          return this.$t(`individual.label_input`);
        default:
          return this.$t(`message.common_title_confirmation`);
      }
    },
    /**
     * 特定のDTCを参照する対象システム
     */
    targetSystem() {
      if (DiagSystemUtils.isAirbagByAbbreviationId(getAbbrSysName(this.systemId))) return 'ABG';
      if (DiagSystemUtils.isOccupantDetectionByAbbreviationId(getAbbrSysName(this.systemId))) return 'OCPT';
      return '';
    }
  },
  methods: {
    ...mapActions('auth', ['logout', 'resetSession']),

    /** 初期化処理 */
    init() {
      this.modal_requirement_049 = true;
      // EUCキーの取得
      this.systemId = individualDiagnose.getCurrentSystemId(this);
      // 初期表示画面の表示文言設定
      this.displayInfo = this.i18nWsKey + '.REQ_WS_49_TXT_1';
    },

    /** OKボタン押下 DTC読出し実行 */
    async dtcReadProcess(timerCountFlg) {
      await this.dtcRead(timerCountFlg);
    },
    /** OKボタン押下 データ読出し実行 */
    async readProcess() {
      await this.read();
    },
    /** OKボタン押下 終了処理実行(共通エラー画面のみの為、Exit処理の結果は考慮しない) */
    async exitProcess() {
      try {
        this.isLoading = true;
        await this.exit();
      } finally {
        this.isLoading = false;
        this.closeWizard();
      }
    },
    /** OKボタン押下 Close実行 */
    async closeProcess() {
      // Wizardを閉じる
      this.closeWizard();
    },

    /**
     * API 通信で共通バリデーションでエラーが発生した際のコールバック
     * @param {object} result バリデーション結果
     */
    validateErrorResult(result) {
      individualDiagnose.apiErrorDefaultAction(
        this,
        result,
        // ログアウト処理のコールバック
        (self) => { self; this.logout(this); },
        // セッションリセット処理のコールバック
        (self) => { self; this.resetSession(this); },
        // その他エラー発生のコールバック
        (result) => { result; this.showUnexpectedError(); },
      );
    },

    /** 
     * DTC読み出し（要求）
     * @param {int} timerCountFlg 呼び出し元（false: 車両状態確認, true: センサ0点調整注意事項表示4）
     */
    async dtcRead(timerCountFlg) {
      try {
        if (timerCountFlg) {
          // センサ0点調整注意事項表示からの場合、画面を遷移しカウントダウンを実行する
          this.displaySec = this.timeRemainSec;
          this.displayInfo = this.$t(`${this.i18nWsKey}.REQ_WS_49_TXT_8_0001`).replace('$TIME$', this.displaySec);
          this.phase = PHASE.CREW_DETECTION;
          await this.countDown();
        }

        this.isLoading = true;
        const token = session.getToken();
        // DTC読み出し
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: !timerCountFlg ? 'dtc_read' : 'dtc_read_2nd'
          },
          // エラー発生のコールバック
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          // ポーリングが正常に完了した場合
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              if (!timerCountFlg) {
                // wait_time取得
                this.timeRemainSec = response.data.user_data.wait_time;
                // キャリブレーション不良対象DTCが含まれているか判別
                const chk = response.data.user_data.dtc_list.some((element) => {
                  return calibrationFailureDTC[this.targetSystem].some((consDtc) => { return element === consDtc; });
                });
                // HACK: Phase4Step2-2終了間際にESLintのルールが変更になり、ロジックは変更出来なかったため回避。
                /* eslint-disable max-depth */
                if (chk) {
                  // 含まれている場合(true)、キャリブレーション不良表示に遷移。
                  this.displayInfo = this.i18nWsKey + '.REQ_WS_49_TXT_3';
                  this.phase = PHASE.CALIBRATION;
                } else {
                  // 含まれていない場合(false)、センサ０点調整注意事項表示に遷移。
                  this.displayInfo = this.i18nWsKey + '.REQ_WS_49_TXT_4';
                  this.phase = PHASE.POINT_PRECAUTIONS1;
                }
              } else {
                // 乗員検知システム故障 対象外のDTCを排除
                const chkArr = response.data.user_data.dtc_list.filter((element) => {
                  return !notSubjectDTC[this.targetSystem].includes(element);
                });
                // 対象外のDTC以外のDTCが存在していた場合はエラー処理
                if (chkArr.length > 0) {
                  this.displayInfo = this.i18nWsKey + '.REQ_WS_49_TXT_23';
                  this.phase = PHASE.FAILED_SYSTEM_FAILURE;
                } else {
                  await this.execute();
                }
              }
              break;
            default:
              this.showUnexpectedError();
              break;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** 実行処理 */
    async execute() {
      const token = session.getToken();
      const response = await individualWorkSupportUtil.pollingWspApi(
        this,
        this.netAppId,
        this.systemId,
        this.workSupportId,
        {
          id_token: token.id_token,
          type: 'execute'
        },
        // エラー発生のコールバック
        (errorType) => { errorType; this.showUnexpectedError(); },
        // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
        (result) => { this.validateErrorResult(result); },
        // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
        (result) => { this.validateErrorResult(result); },
      );

      if (response) {
        switch (response.data.status) {
          case config.STATUS_WSP_COMPLETED:
            // RoutineStatusが0002(正常終了)の場合
            if (response.data.user_data.routine_status === '0002') {
              if (await this.callExit()) {
                this.displayInfo = this.i18nWsKey + '.REQ_WS_49_TXT_9_0002';
                this.phase = PHASE.SUCCESS_POINT;
              }
            } else {
              if (await this.callExit()) {
                // RoutineStatusが0002(正常終了)以外の場合
                this.displayInfo = this.$t(`${this.i18nWsKey}.REQ_WS_49_TXT_25`).replace('$ROUTINESTATUS$', response.data.user_data.routine_status);
                this.phase = PHASE.FAILED_POINT;
              }
            }
            break;
          case config.STATUS_WSP_FAILED:
            switch (response.data.async_code) {
              // ルーチン実行・ルーチン結果確認で異常終了
              case error.WSP_EXECUTION_TIMEOUT_ERROR:
                if (await this.callExit()) {
                  this.displayInfo = this.i18nWsKey + '.REQ_WS_49_TXT_24';
                  this.phase = PHASE.FAILED_TIMEOUT;
                }
                break;
              // 上記以外(NonDefaultSession遷移、セキュリティアクセス)で異常終了
              default:
                this.showUnexpectedError();
                break;
            }
            break;
          default:
            this.showUnexpectedError();
            break;
        }
      }
    },

    /** Exit処理呼び出し(executeから) */
    async callExit() {
      // DefaultSession遷移
      const exitResponse = await this.exit();
      if (exitResponse) {
        if (exitResponse.data.status === config.STATUS_WSP_COMPLETED) {
          return true;
        } else {
          this.showUnexpectedError();
          return false;
        }
      } else {
        this.showUnexpectedError();
        return false;
      }
    },

    /** データ読み出し */
    async read() {
      try {
        // 処理実行前にカウントダウン
        this.displaySec = this.timeRemainSec;
        this.displayInfo = this.$t(`${this.i18nWsKey}.REQ_WS_49_TXT_20`).replace('$TIME$', this.displaySec);
        this.phase = PHASE.READOUT;
        await this.countDown();

        this.isLoading = true;
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'read'
          },
          // エラー発生のコールバック
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED: {
              const userData = response.data.user_data;
              let massWeight = userData.mass_weight;
              // data_typeがdecExStrまたはValueの場合、独自の変換を行う（単位不要）
              if (userData.data_type === 'decExStr') {
                // 合計荷重値情報のDID(1054)とdata_recordを組み合わせる
                const hex = '1054_1_all_' + utils.addPadding(massWeight, 2).toUpperCase();
                // 文字列に変換を行う
                if (this.$te(`wsDid${this.systemId}.${hex}`)) {
                  massWeight = this.$t(`wsDid${this.systemId}.${hex}`);
                } else {
                  // 文字列に変換できなかった場合、数値に変換する
                  massWeight = utils.convertHexOfDidToInt(userData, massWeight);
                }
              } else if (userData.data_type === 'Value') {
                if (massWeight || massWeight === 0) {
                  if ((typeof massWeight === 'number') && userData.digits_after_decimal !== null) {
                    //小数点以下編集
                    massWeight = fixNumberWithDecimal(massWeight, userData.digits_after_decimal);
                  }
                }
              }
              //変換成功判定処理
              if (this.checkWeightMass(massWeight, userData.digits_after_decimal)) {
                this.displayInfo = this.setMessageSpan(this.$t(`${this.i18nWsKey}.REQ_WS_49_TXT_21`)
                  .replace('$DID$', massWeight)
                  .replace('$USER$', this.inputWeight), true);
                this.phase = PHASE.SUCCESS_SENSITIVITY;
              } else {
                this.displayInfo = this.setMessageSpan(this.$t(`${this.i18nWsKey}.REQ_WS_49_TXT_22`)
                  .replace('$DID$', massWeight)
                  .replace('$USER$', this.inputWeight), false);
                this.phase = PHASE.CONDITION_FAILED;
              }
              break;
            }
            default:
              this.displayInfo = this.i18nWsKey + '.REQ_WS_49_TXT_26';
              this.phase = PHASE.FAILED_SENSITIVITY;
              break;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** 終了処理 */
    async exit() {
      const token = session.getToken();
      return await individualWorkSupportUtil.pollingWspApi(
        this,
        this.netAppId,
        this.systemId,
        this.workSupportId,
        {
          id_token: token.id_token,
          type: 'exit'
        },
        // エラー発生のコールバック
        (errorType) => { errorType; this.showUnexpectedError(); },
        // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
        (result) => { this.validateErrorResult(result); },
        // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
        (result) => { this.validateErrorResult(result); },
      );
    },

    /** OKボタン押下時、画面遷移のみを行う */
    changeForm() {
      switch (this.phase) {
        // 開始確認から車両状態確認へ
        case PHASE.START:
          this.displayInfo = this.i18nWsKey + '.REQ_WS_49_TXT_2';
          this.phase = PHASE.CONDITION_CHECK;
          break;
        //  キャリブレーション不良表示からセンサ0点調整注意事項表示1へ
        case PHASE.CALIBRATION:
          this.displayInfo = this.i18nWsKey + '.REQ_WS_49_TXT_4';
          this.phase = PHASE.POINT_PRECAUTIONS1;
          break;
        // センサ0点調整注意事項表示1からセンサ0点調整注意事項表示2へ
        case PHASE.POINT_PRECAUTIONS1:
          this.displayInfo = this.i18nWsKey + '.REQ_WS_49_TXT_5';
          this.phase = PHASE.POINT_PRECAUTIONS2;
          break;
        // センサ0点調整注意事項表示2からセンサ0点調整注意事項表示3へ
        case PHASE.POINT_PRECAUTIONS2:
          this.displayInfo = this.i18nWsKey + '.REQ_WS_49_TXT_6';
          this.phase = PHASE.POINT_PRECAUTIONS3;
          break;
        // センサ0点調整注意事項表示3からセンサ0点調整注意事項表示4へ
        case PHASE.POINT_PRECAUTIONS3:
          this.displayInfo = this.i18nWsKey + '.REQ_WS_49_TXT_7';
          this.phase = PHASE.POINT_PRECAUTIONS4;
          break;
        // センサ0点調整成功表示からセンサ感度検査注意事項表示1へ
        case PHASE.SUCCESS_POINT:
          this.displayInfo = this.i18nWsKey + '.REQ_WS_49_TXT_10';
          this.phase = PHASE.SENSITIVITY_PRECAUTIONS1;
          break;
        // センサ感度検査注意事項表示1からセンサ感度検査注意事項表示2へ
        case PHASE.SENSITIVITY_PRECAUTIONS1:
          this.displayInfo = this.i18nWsKey + '.REQ_WS_49_TXT_11';
          this.phase = PHASE.SENSITIVITY_PRECAUTIONS2;
          break;
        // センサ感度検査注意事項表示2からセンサ感度検査注意事項表示3へ
        case PHASE.SENSITIVITY_PRECAUTIONS2:
          this.displayInfo = this.i18nWsKey + '.REQ_WS_49_TXT_12';
          this.phase = PHASE.SENSITIVITY_PRECAUTIONS3;
          break;
        // センサ感度検査注意事項表示3からセンサ感度検査注意事項表示4へ
        case PHASE.SENSITIVITY_PRECAUTIONS3:
          this.displayInfo = this.i18nWsKey + '.REQ_WS_49_TXT_13';
          this.phase = PHASE.SENSITIVITY_PRECAUTIONS4;
          break;
        // センサ感度検査注意事項表示4からセンサ感度検査注意事項表示5へ
        case PHASE.SENSITIVITY_PRECAUTIONS4:
          this.displayInfo = this.i18nWsKey + '.REQ_WS_49_TXT_14';
          this.phase = PHASE.SENSITIVITY_PRECAUTIONS5;
          break;
        // センサ感度検査注意事項表示5からセンサ感度検査注意事項表示6へ
        case PHASE.SENSITIVITY_PRECAUTIONS5:
          this.displayInfo = this.i18nWsKey + '.REQ_WS_49_TXT_15';
          this.phase = PHASE.SENSITIVITY_PRECAUTIONS6;
          break;
        // センサ感度検査注意事項表示6からセンサ感度検査注意事項表示7へ
        case PHASE.SENSITIVITY_PRECAUTIONS6:
          this.displayInfo = this.i18nWsKey + '.REQ_WS_49_TXT_16';
          this.phase = PHASE.SENSITIVITY_PRECAUTIONS7;
          break;
        // センサ感度検査注意事項表示7から錘質量入力指示表示へ
        case PHASE.SENSITIVITY_PRECAUTIONS7:
          this.displayInfo = this.i18nWsKey + '.REQ_WS_49_TXT_17';
          this.phase = PHASE.INPUT_INST;
          break;
        // 錘質量入力指示表示から錘質量入力へ
        case PHASE.INPUT_INST:
          this.displayInfo = this.i18nWsKey + '.REQ_WS_49_TXT_18';
          this.phase = PHASE.INPUT;
          break;
        case PHASE.INPUT:
          if (this.inputWeight.length === 0) {
            // 未入力のため錘質量入力から錘質量入力指示表示へ（キャンセル押下時の処理を実行）
            this.cancelProcess();
            return;
          }
          this.isAlertValidation = inputValidator.excuteValidateCommons(this.inputWeight, true, 0, 6);
          if (this.isAlertValidation.valid === false) {
            // バリデーション結果を表示
            return;
          } else {
            // 錘質量入力から検査準備表示へ
            this.displayInfo = this.i18nWsKey + '.REQ_WS_49_TXT_19';
            this.phase = PHASE.INSPECTION_PRE;
          }
          break;
      }
    },
    /** クリアボタン押下時 */
    clearText() {
      this.inputWeight = '';
    },
    /** 錘質量入力 キャンセルボタン押下時 */
    cancelProcess() {
      this.clearText();
      this.isAlertValidation = {};
      this.displayInfo = this.i18nWsKey + '.REQ_WS_49_TXT_17';
      this.phase = PHASE.INPUT_INST;
    },
    /** 錘質量入力イベント(+, -, e, Eの入力を無効に) */
    portKeydown(e) {
      if (this.inputWeight.length === 0 || this.inputWeight.length >= 5) {
        if (/^\.$/.test(e.key)) {
          e.preventDefault();
        }
      }
      if (/^\+$/.test(e.key)) {
        e.preventDefault();
      }
      if (/^-$/.test(e.key)) {
        e.preventDefault();
      }
      if (/^e$/.test(e.key)) {
        e.preventDefault();
      }
      if (/^E$/.test(e.key)) {
        e.preventDefault();
      }
    },
    /** 残り時間カウントダウン */
    async countDown() {
      return new Promise((resolve) => {
        this.timerID = setInterval(() => {
          this.displaySec--;
          // まったくおなじ文言だが、一応切り分け
          if (this.phase === PHASE.CREW_DETECTION) {
            this.displayInfo = this.$t(`${this.i18nWsKey}.REQ_WS_49_TXT_8_0001`).replace('$TIME$', this.displaySec);
          } else {
            this.displayInfo = this.$t(`${this.i18nWsKey}.REQ_WS_49_TXT_20`).replace('$TIME$', this.displaySec);
          }

          if (this.displaySec === 0) {
            clearInterval(this.timerID);
            resolve();
          }
        }, 1000);
      });
    },
    /** 規格値チェック
     * @param {number} weight 読み出し値
     * @param {number} digits 計算結果の少数点以下の桁数
     * @returns {boolean} true: 合格  false 不合格
     */
    checkWeightMass(weight, digits) {
      // weightが数値でない場合、falseを返す
      const weightVal = Number(weight);
      if (isNaN(weightVal)) {
        return false;
      }
      let result = true;
      // 誤差が発生するため算出結果の小数点以下編集
      // 例）65.54 - 63.04 = 2.500000000000007 となり不合格と判定される
      const chk = fixNumberWithDecimal(parseFloat(weight) - parseFloat(this.inputWeight), digits);

      if (chk < -2.5) {
        result = false;
      } else if (chk > 2.5) {
        result = false;
      }
      return result;
    },
    /**
     * 赤字用spanタグ付与
     * @param {string} message 処理する表示文言
     * @param {string} flg     true: 合格表示時  false: 不合格表示時
     * return 処理済みの表示文言(span付与)
     */
    setMessageSpan(message, flg) {
      const messageArr = message.split('\n');
      let str = "";
      if (flg) {
        str = messageArr[7];
        messageArr[7] = '<span style= "color: #FF0000;">' + str + '</span>';
      } else {
        str = messageArr[9];
        messageArr[9] = '<span style= "color: #FF0000;">' + str + '</span>';
      }
      return messageArr.join('\n');
    },

    /** その他エラーの表示 */
    showUnexpectedError() {
      if (this.phase === PHASE.FAILED) {
        this.closeWizard();
        return;
      }
      this.displayInfo = 'individual.error_communication_error';
      this.phase = PHASE.FAILED;
    },

    /** Wizardを閉じる */
    async closeWizard() {
      this.$emit('close-wizard');
      this.modal_requirement_049 = false;
    },
  },

  async mounted() {
    this.init();
  },
};
